import { REQUEST, SUCCESS, ERROR } from './types'

const state = {
  data: {
    docs: [],
    page: 1,
    perPage: 1000,
    total: 0
  },
  loading: false,
  error: false
}

const getters = {
  isLoading: state => state.loading,
  isError: state => state.error,
  carriersList: state => state.data
}

const actions = {
  async get ({ commit, dispatch }, query) {
    commit(REQUEST)

    const { data } = await dispatch(
      `api`,
      { entity: `carriers`, action: `get`, query },
      { root: true }
    )

    if (data) {
      commit(SUCCESS, data)
    } else {
      commit(ERROR)
    }
  }
}

const mutations = {
  [REQUEST] (state) {
    state.loading = true
  },
  [SUCCESS] (state, payload) {
    state.data = payload
    state.loading = false
    state.error = false
  },
  [ERROR] () {
    state.error = true
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
